type FiltersType = {
  id: string;
  value: string 
};

type SortsType = {
  id: string;
  value: string 
};

export type fetchShippingsPayload = {
  filters: FiltersType[] | [];
  sort: SortsType[] | [];
  pagination: {
    limit: number;
    activePage: number;
  }
};

export const fetchShippings = async(payload: fetchShippingsPayload) => {
  const apiURL = process.env.REACT_APP_API_URL+"/shipping/list";

  try {
    const response = await fetch(apiURL, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });
  
    if(!response.ok) {
      console.log(`HTTP Error! Status : ${response.status}`);
      return;
    };
  
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error);
    return;
  }
};

export const fetchShippingDetails = async(shippingNumber: string) => {
  const apiURL = `${process.env.REACT_APP_API_URL}/shipping/detail/${shippingNumber}`;

  try {
    const response = await fetch(apiURL, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
      }
    });
  
    if(!response.ok) {
      console.log(`HTTP Error! Status : ${response.status}`);
      return;
    };
  
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error);
    return;
  }
};